module.exports = __webpack_public_path__ + "static/return_service-99ea1ecc03d821e08a91dde22eda8439.jpg";